import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Header from "@/components/Header";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import PricingPage from "@/pages/PricingPage";
import PaymentResult from "@/pages/PaymentResult";
import AdminPage from "@/pages/AdminPage";
import AuthLayout from "@/pages/AuthLayout";
import TeamPage from "@/pages/TeamPage";
import UpgradePage from "@/pages/UpgradePage";

const Protected = ({ children }) => {
  const loc = useLocation();
  const back = encodeURIComponent(`${loc.pathname}${loc.search}`);
  return (
    <>
      <Show when="signed-in">{children}</Show>
      <Show when="signed-out"><Navigate to={`/sign-in?redirect_url=${back}`} replace /></Show>
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <div className="min-h-screen bg-[#F8FAFC] text-slate-900">
          <Header />
          <Routes>
            <Route path="/" element={<><Show when="signed-in"><Dashboard /></Show><Show when="signed-out"><Landing /></Show></>} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/payment/success" element={<Protected><PaymentResult success /></Protected>} />
            <Route path="/payment/cancel" element={<Protected><PaymentResult /></Protected>} />
            <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
            <Route path="/team" element={<Protected><TeamPage /></Protected>} />
            <Route path="/upgrade" element={<Protected><UpgradePage /></Protected>} />
            <Route path="/sign-in/*" element={<AuthLayout><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthLayout>} />
            <Route path="/sign-up/*" element={<AuthLayout><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthLayout>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="bottom-right" />
        </div>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
